// tslint:disable:object-literal-key-quotes
import { VCLIconAliasMap } from '../icon/index';

export const ALIAS_MAP: VCLIconAliasMap = {
  'close': 'mdi mdi-close',
  'busy': 'mdi mdi-loading mdi-spin',
  'box': 'mdi mdi-checkbox-blank-outline',
  'box-checked': 'mdi mdi-check-box-outline',
  'circle': 'mdi mdi-radiobox-blank',
  'circle-checked': 'mdi mdi-radiobox-marked',
  'question': 'mdi mdi-help',
  'info': 'mdi mdi-information',
  'success': 'mdi mdi-check',
  'warning': 'mdi mdi-alert',
  'error': 'mdi mdi-alert-circle',
  'arrow-left': 'mdi mdi-chevron-left',
  'arrow-right': 'mdi mdi-chevron-right',
  'arrow-up': 'mdi mdi-chevron-up',
  'arrow-down': 'mdi mdi-chevron-down',
  'arrow-double-left': 'mdi mdi-chevron-double-left',
  'arrow-double-right': 'mdi mdi-chevron-double-right',
  'arrow-double-down': 'mdi mdi-chevron-double-down',
  'arrow-double-up': 'mdi mdi-chevron-double-up',
  'upload': 'mdi mdi-upload',
  'eye': 'mdi mdi-eye',
  'eye-off': 'mdi mdi-eye-off',
  'star': 'mdi mdi-star',
  'star-half': 'mdi mdi-star-half',
  'star-empty': 'mdi mdi-star-outline',
  'add': 'mdi mdi-plus',
  'remove': 'mdi mdi-minus',
  'calendar': 'mdi mdi-calendar',
  'clock': 'mdi mdi-clock-outline',
  'menu': 'mdi mdi-menu'
};
